module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex w-100"
  }, [_c('input', {
    staticClass: "bg-lighter flexGrow1",
    attrs: {
      "placeholder": _vm.placeholder,
      "type": "text"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event.target.value)
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$emit('search')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn wider blue ml-3 w-80",
    on: {
      "click": function($event) {
        return _vm.$emit('search')
      }
    }
  }, [_vm._v("Search")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-0c82db1c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c82db1c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/ReservationsSearchBar.vue
// module id = 2795
// module chunks = 0